import { render, staticRenderFns } from "./msInput.vue?vue&type=template&id=672d7626&scoped=true"
import script from "./msInput.vue?vue&type=script&lang=js"
export * from "./msInput.vue?vue&type=script&lang=js"
import style0 from "./msInput.vue?vue&type=style&index=0&id=672d7626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672d7626",
  null
  
)

export default component.exports